export default "__VITE_ASSET__XuzskRM3__"